import { render } from "./App.vue?vue&type=template&id=ab2d12d8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ab2d12d8&lang=scss"

import exportComponent from "G:\\web2\\豪哥\\盘龙山陵园\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__